module.exports = __webpack_public_path__ + "static/021-c7a00cba329ba9259b4963da1d1a7364.jpg";